import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  useEffect(() => {
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/admin/login"); return; }
    const sessionId = m[1];
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        window.location.hash = "";
        if (!data.is_admin) {
          toast.error("This email is not on the admin allowlist.");
          navigate("/admin/login", { replace: true });
          return;
        }
        navigate("/admin", { replace: true, state: { user: data } });
      } catch (e) {
        toast.error("Authentication failed");
        navigate("/admin/login", { replace: true });
      }
    })();
  }, [navigate]);
  return (
    <div className="pt-32 min-h-screen flex items-center justify-center" data-testid="page-auth-callback">
      <div className="text-slate">Signing you in…</div>
    </div>
  );
}
